/**
 * 地块划界所用的地图组件，支持在地图上绘制一个园区的地理轮廓
 */
import BMapProxy from '@/common/BMapProxy.js'
import Points2Geo from '@/common/Points2Geo.js'
import * as mapvgl from 'mapvgl'

function Map() {
  var map
  var view
  var outline
  var proxy
  /**
   *  
   * @param {String} container 
   */
  this.init = function (container, p) {
    proxy = new BMapProxy()
    proxy.init(container, 2).then((m, v) => {
      map = m
      view = v
      proxy.fly2(117.17425174628049, 32.48339622720056, 13).then(() => {
        console.log('地图加载完成！', map.getBounds())
      })
      p.$set(p, 'mapLoaded', true)
    })

  }
  this.init2 = function (container, v) {
    proxy = new BMapProxy()
    proxy.init2(container).then((obj) => {
      map = obj.map
      view = obj.view
      map.centerAndZoom(new BMapGL.Point(117.17425174628049, 32.48339622720056), 13)
      v.$set(v, 'mapLoaded', true)
    })
  }
  //地块初始化地图
  this.drawPark = function (landData) {
    map.clearOverlays()
    landData.forEach(p => {
      var array = []
      let land = p.position
      if (land == null) {
        return
      }
      var marker = new BMapGL.Marker(new BMapGL.Point(p.lng, p.lat))
      var label = new BMapGL.Label(p.name, {
        offset: new BMapGL.Size(10, -25)
      })
      label.setStyle({
        display: "block",
        color: "red",
        fontSize: "12px",
        height: "20px",
        lineHeight: "20px",
        fontFamily: "微软雅黑"
      })
      marker.setLabel(label)
      map.addOverlay(marker)

      land.forEach(element => {
          array.push(new BMapGL.Point(element.lng, element.lat))
        }),
        outline = new BMapGL.Polygon(
          array, {
            strokeColor: 'blue',
            strokeWeight: 2,
            strokeOpacity: 0.5
          })
      map.addOverlay(outline)

    })
  }
  this.drawPark2 = function (parkArr) {
      parkArr.forEach(park=>{
        proxy.fly2(park.lng, park.lat, 15, {
          tilt: 0
        })
        const geojson = Points2Geo.asLineString(park.position)
        const landLyr = new mapvgl.PolygonLayer({
          fillColor: 'rgba(72,255,39,.65)', // 填充颜色
          lineWidth: 4,
          lineColor: '#339c03',
          enablePicked: false, // 是否可以拾取
        })
        view.addLayer(landLyr)
        landLyr.setData([geojson])
        // view.addLayer(new mapvgl.WallLayer({
        //   gradient: {
        //     1: 'rgba(30, 236, 50, .7)',
        //     0: 'rgba(50, 256, 70, .4)'
        //   },
        //   data: [geojson]
        // }))
        // view.addLayer(new mapvgl.WallTripLayer({
        //   gradient: {
        //     1: 'rgba(30, 236, 50, .8)',
        //     0: 'rgba(50, 256, 70, .2)'
        //   },
        //   data: [geojson]
        // }))
      })
  
  }
  /**
   * 企业地块地图绘制
   * @param {array} lands 
   */
  this.drawLands = function (lands) {

    // })

    var array = []
    let land = JSON.parse(lands.position)
    if (land) {
      land.forEach(element => {
          array.push(new BMapGL.Point(element.lng, element.lat))
        }),
        outline = new BMapGL.Polygon(

          array, {
            strokeColor: 'blue',
            strokeWeight: 2,
            strokeOpacity: 0.5
          })
      map.addOverlay(outline)
      outline.enableEditing()
    }

  }
  //获取保存的地块边界数据
  this.getPath = function () {
    let point = outline.getBounds()
    let centerx = (point.maxX + point.minX) / 2
    let centerY = (point.maxY + point.minY) / 2
    let array = [outline.getPath(), centerx, centerY]
    return array
  }
  //画地块点击事件
  this.drawing = function () {
    const {
      sw,
      ne
    } = map.getBounds()
    const lng = (sw.lng + ne.lng) / 2
    const lat = (sw.lat + ne.lat) / 2
    const {
      width,
      height
    } = map.getBounds().toSpan()
    outline = new BMapGL.Polygon([
      new BMapGL.Point(lng - width * 0.2, lat + height * 0.2),
      new BMapGL.Point(lng + width * 0.2, lat + height * 0.2),
      new BMapGL.Point(lng + width * 0.2, lat - height * 0.2),
      new BMapGL.Point(lng - width * 0.2, lat - height * 0.2)
    ], {
      strokeColor: 'blue',
      strokeWeight: 4,
      strokeOpacity: 0.5
    })
    map.addOverlay(outline)
    outline.enableEditing()
  }

  //显示轮廓按钮
  this.drawOutLine = function () {
    const {
      width,
      height
    } = map.getBounds().toSpan()
    const {
      lng,
      lat
    } = map.getCenter()
    outline = new BMapGL.Polygon([
      new BMapGL.Point(lng - width * 0.4, lat + height * 0.4),
      new BMapGL.Point(lng + width * 0.4, lat + height * 0.4),
      new BMapGL.Point(lng + width * 0.4, lat - height * 0.4),
      new BMapGL.Point(lng - width * 0.4, lat - height * 0.4)
    ], {
      strokeColor: 'blue',
      strokeWeight: 2,
      strokeOpacity: 0.5
    })
    // map.removeOverlay(overOutline)
    map.addOverlay(outline)
    outline.enableEditing()

  }
  this.destroy = function () {
    if (map && map.destroy)
      map.destroy()
  }


}

export default new Map()



// WEBPACK FOOTER //
// ./src/components/meta/land/locate-map.js